// components/ToastContext.js
import React, { createContext, useContext, useCallback, useState } from "react";
import Toast from "./Toast";

const ToastContext = createContext();

export function useToasts() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  // Show a new toast
  const showToast = useCallback(
    (message, type = "success", duration = 2200, position = "bottom-right") => {
      const id = Math.random().toString(36).slice(2, 11); // short unique id
      setToasts((t) => [
        ...t,
        { id, message, type, duration, position }
      ]);
      // Auto-remove after duration
      setTimeout(() => {
        setToasts((t) => t.filter((toast) => toast.id !== id));
      }, duration + 360); // extra for fade out
    },
    []
  );

  // Remove toast (manual close)
  const removeToast = useCallback((id) => {
    setToasts((t) => t.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Render the stacked toasts */}
      <div style={{ position: "fixed", zIndex: 'var(--z-toast)', right: 32, bottom: 30 }}>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={() => removeToast(toast.id)}
            position={toast.position}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
}
